
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { Component, Prop, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { handleError, initClient } from '../../../../../api';
import { Cell, CellClient, Inventory, SetCellInventoriesRequest } from '../../../../backend/backendapi';
import { paginationOptions, searchOptions } from '../../../../../util/vue-good-table';
import MediaPicker from '../../../../mediapicker/MediaPicker';

@Component({
  components: {
    MediaPicker,
    VueGoodTable,
    vSelect,
  },
})
export default class EditModal extends Vue {
  @Prop({ required: true })
  readonly cell!: Cell;
  @Prop({ required: true })
  readonly inventories!: Inventory[];

  //runtime
  readonly linkedInventories: Inventory[] = [];
  inventoryToAdd: Inventory | null = null;

  //api
  readonly cellAPI = initClient(CellClient);

  get availableInventories(): Inventory[] {
    let linked = new Set(this.linkedInventories.map(e => e.id));
    return this.inventories.filter(e => !linked.has(e.id));
  }

  get invColumnsConfig(): unknown[] {
    return [
      {
        label: this.$t('txtInvName').toString(),
        field: (e: Inventory) => e.name,
      },
      {
        label: this.$t('txtInvSupplier').toString(),
        field: (e: Inventory) => e.supplier,
      },
      {
        label: this.$t('txtInvIdent').toString(),
        field: (e: Inventory) => e.ident,
      },
      {
        label: this.$t('txtActions').toString(),
        field: 'actions',
      },
    ];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  addInventory(): void {
    if (!this.cell) {
      return;
    }
    if (!this.inventoryToAdd) {
      return;
    }
    this.linkedInventories.push(this.inventoryToAdd);
    this.inventoryToAdd = null;

    this.cellAPI.setCellInventories(new SetCellInventoriesRequest({ cellId: this.cell.id!, inventoryIds: this.linkedInventories.map(e => e.id!) }))
        .then(_ => this.$toasted.info(this.$t('txtSaved').toString()))
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  async fetchCellLinkedInventories(id: number): Promise<void> {
    this.linkedInventories.splice(0);
    this.linkedInventories.push(...await this.cellAPI.getLinkedInventories(id).then(e => e.result!));
  }

  removeInventory(inv: Inventory): void {
    let index = this.linkedInventories.findIndex(e => e.id === inv.id);
    if (index === -1) {
      return;
    }
    this.linkedInventories.splice(index, 1);

    this.cellAPI.setCellInventories(new SetCellInventoriesRequest({ cellId: this.cell.id!, inventoryIds: this.linkedInventories.map(e => e.id!) }))
        .then(_ => this.$toasted.info(this.$t('txtSaved').toString()))
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  @Watch('cell.id', { immediate: true })
  private onCellChanged(): void {
    this.fetchCellLinkedInventories(this.cell.id);
  }
}
